<template>
<div class="chapter">
<div class="inner_page">
<p class="space"> </p>
<p class="copyright3"><a id="Copyright">Copyright © Seaforth Publishing 2007</a></p><a id="Copyright">
</a><p class="copyright3"><a id="Copyright">First published in Great Britain in 2007 by<br/>
Seaforth Publishing<br/>
An imprint of Pen &amp; Sword Books Ltd<br/>
47 Church Street<br/>
Barnsley<br/>
S Yorkshire S70 2AS<br/>
</a><a href="http://www.pen-and-sword.co.uk" target="_blank">www.pen-and-sword.co.uk</a></p>
<p class="copyright3">And in the United States of America by<br/>
Classic Warships Publishing,<br/>
PO Box 57591, Tucson, Arizona 85732<br/>
<a href="http://www.classicwarships.com" target="_blank">www.classicwarships.com</a></p>
<p class="copyright3">The publishers would like to thank D K<br/>
Brown and John Roberts for help with<br/>
illustration.</p>
<p class="copyright3"><i>British Library Cataloguing in Publication Data</i><br/>
Backer, Steve<br/>
    British battlecruisers of the Second<br/>
    World War. -<br/>
  (ShipCraft)<br/>
  1. Warships - Models<br/>
 I. Title II. Richardson, George<br/>
 623.8'20153<br/>
  ISBN-13: 9781844156986</p>
<p class="copyright3">  PAPERBACK ISBN: 978-1-84415-698-6<br/>
  PDF ISBN: 978-1-47382-945-9<br/>
  EPUB ISBN: 978-1-47382-670-0<br/>
  PRC ISBN: 978-1-47382-626-7</p>
<p class="copyright3">All rights reserved. No part of this publication<br/>
may be reproduced or transmitted in any form or<br/>
by any means, electronic or mechanical,<br/>
including photocopying, recording, or any<br/>
information storage and retrieval system, without<br/>
either prior permission in writing from the<br/>
publisher or a licence permitting restricted<br/>
copying.</p>
<p class="copyright3">Typeset and designed by Sally Geeve<br/>
Printed and bound in China through Printworks<br/>
International Ltd</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Copyright.vue?2552788c